module.exports = __webpack_public_path__ + "img/md.8f2e007.svg";